import { render, staticRenderFns } from "./Eyes.vue?vue&type=template&id=2f4ad05c&"
import script from "./Eyes.vue?vue&type=script&lang=ts&"
export * from "./Eyes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4ad05c')) {
      api.createRecord('2f4ad05c', component.options)
    } else {
      api.reload('2f4ad05c', component.options)
    }
    module.hot.accept("./Eyes.vue?vue&type=template&id=2f4ad05c&", function () {
      api.rerender('2f4ad05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/v2/Eyes.vue"
export default component.exports